import { Module } from "vuex";
import { ISOAState } from "@/core/interfaces/soaState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const soaModule: Module<ISOAState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default soaModule;
